// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "./default/chunk-article-listed.f0e1a51cd12a162c0df0.js";
	if (chunkId === 38) return "./default/chunk-subscription.ce2b85a3487058ded573.js";
	if (chunkId === 66) return "./66.62ffd0345ac8366da33e.js";
	if (chunkId === 36) return "./default/chunk-small-gallery.2c32ae434289a23e119d.js";
	if (chunkId === 32) return "./default/chunk-photo-credit-toogle.a48178caa133c17d5f24.js";
	if (chunkId === 37) return "./default/chunk-social-click.55a0056263d8321cf237.js";
	if (chunkId === 40) return "./default/chunk-table.0007846a756b0577f46d.js";
	if (chunkId === 44) return "./default/gallery-in-art-preserve-scroll.596971736fbdeff7000c.js";
	if (chunkId === 67) return "./67.c0fc087683dbf7f3498e.js";
	if (chunkId === 31) return "./default/chunk-online-reports.c5987be8f32b412d8555.js";
	if (chunkId === 6) return "./chunk-league-table.1d6639e4a3f012f77e2a.js";
	// return url for filenames based on template
	return undefined;
};